import update from 'immutability-helper';

import {
  CHANGE_FEEDBACK_INPUT,
  SET_FEEDBACK_RATING,
  SUBMIT_FEEDBACK_ERROR,
  SUBMIT_FEEDBACK_SUCCESS,
  FEEDBACK_STATUS_INITIAL,
  FEEDBACK_STATUS_SUCCESS,
  FEEDBACK_STATUS_ERROR,
  FEEDBACK_STATUS_VALIDATION,
  FETCH_FEEDBACK_REQUEST,
  FETCH_FEEDBACK_SUCCESS,
  FETCH_FEEDBACK_ERROR,
  RATE_FEEDBACK,
} from './constants';
import { SET_FEEDBACK_PAGE_NUMBER, SET_FEEDBACK_SORT_BY } from '../feedback/constants';

const initialState = {
  Name: '',
  Email: '',
  Comment: '',
  Rating: null,
  status: FEEDBACK_STATUS_INITIAL,
  rand: null, // random number used to relaunch selectors and read from cookie
  pageNumber: 1,
  isFetchInProgress: false,
  fetchedList: [],
  errors: {},
  errorMessage: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHANGE_FEEDBACK_INPUT:
      if (action.name !== null) {
        state = update(state, { Name: { $set: action.name }, errors: { $unset: ['Name'] } });
      }
      if (action.email !== null) {
        state = update(state, { Email: { $set: action.email }, errors: { $unset: ['Email'] } });
      }
      if (action.comment !== null) {
        state = update(state, {
          Comment: { $set: action.comment },
          errors: { $unset: ['Comment'] },
        });
      }
      return state;
    case SET_FEEDBACK_RATING:
      return { ...state, Rating: action.value };
    case SUBMIT_FEEDBACK_SUCCESS:
      return { ...state, status: FEEDBACK_STATUS_SUCCESS };
    case SUBMIT_FEEDBACK_ERROR: {
      const { details, message } = action;
      return update(state, {
        /** if details object is provided, then it is validation errors, otherwise global */
        status: {
          $set: Object.keys(details).length ? FEEDBACK_STATUS_VALIDATION : FEEDBACK_STATUS_ERROR,
        },
        errors: { $set: details },
        errorMessage: { $set: message },
      });
    }
    case FETCH_FEEDBACK_REQUEST:
      return { ...state, isFetchInProgress: true };
    case FETCH_FEEDBACK_SUCCESS: {
      return update(state, {
        isFetchInProgress: { $set: false },
      });
    }
    case FETCH_FEEDBACK_ERROR: {
      return update(state, {
        isFetchInProgress: { $set: false },
      });
    }
    case RATE_FEEDBACK:
      return update(state, {
        rand: { $set: action.rand },
      });
    case SET_FEEDBACK_PAGE_NUMBER: {
      const { pageNumber } = action;
      return update(state, {
        pageNumber: { $set: pageNumber },
      });
    }
    case SET_FEEDBACK_SORT_BY: {
      const { value } = action;
      return update(state, {
        sortBy: { $set: value },
      });
    }
    default:
      return state;
  }
}
